import * as z from "zod/v4";

export const ShippingAddressToUpdateSchema = z.object({
  address1: z.string().describe("Street address"),
  address2: z
    .string()
    .nullish()
    .describe("Optional: Apartment number or suite number"),
  city: z.string().nullish().describe("Optional: City of the street address"),
  provinceCode: z
    .string()
    .nullish()
    .describe("Optional: Province code of the street address"),
  zip: z
    .string()
    .nullish()
    .describe("Optional: Zip code of the street address"),
  countryCode: z
    .string()
    .nullish()
    .describe("Optional: Country code of the street address"),
  firstName: z
    .string()
    .nullish()
    .describe("Optional: First name of the customer"),
  lastName: z
    .string()
    .nullish()
    .describe("Optional: Last name of the customer"),
});
export type ShippingAddressToUpdate = z.infer<
  typeof ShippingAddressToUpdateSchema
>;

export const ConfirmUpdateOrderShippingAddressSchema = z.object({
  updatedShippingAddress: ShippingAddressToUpdateSchema,
});

export type ConfirmUpdateOrderShippingAddress = z.infer<
  typeof ConfirmUpdateOrderShippingAddressSchema
>;
